module.exports = __webpack_public_path__ + "img/capitano 3.d498a331.jpeg";